import React, { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { useQuoteDomainParams } from 'global/hooks/useQuoteDomainParams';
import QuoteFlowLayout from 'components/common/quote/QuoteFlowLayout';
import { QuoteRouteV2Id } from 'routes/routesConfigV2';
import AddQuotePageStore, {
  AddQuotePageStoreContext,
  useAddQuotePageStore,
} from 'store/pages/quote/add-quote/pageStore';

const PageContent: React.FC = observer(() => {
  const { flowDelegate, isActionLoading, canCompleteStep, onComplete, getInitialData } = useAddQuotePageStore();

  useEffect(() => {
    void getInitialData();
  }, []);

  return (
    <QuoteFlowLayout
      flowDelegate={flowDelegate}
      pageId={QuoteRouteV2Id.INITIATE_SHELF_ADD_QUOTE}
      isPageLoading={flowDelegate.isInitialDataLoading}
      isActionLoading={isActionLoading}
      pageHeader={{ subtitleMaxWidth: '50rem' }}
      pageFooter={{
        onComplete,
        completeButtonText: 'Save',
        disableCompleteButton: !canCompleteStep,
      }}
    >
      Page is in progress
    </QuoteFlowLayout>
  );
});

const AddQuotePage: React.FC = () => {
  const { groupId, periodId, cartId } = useQuoteDomainParams();

  const pageStore = useMemo(() => new AddQuotePageStore({ groupId, periodId, cartId }), []);
  return (
    <AddQuotePageStoreContext.Provider value={pageStore}>
      <PageContent />
    </AddQuotePageStoreContext.Provider>
  );
};

export default AddQuotePage;
